import { Component, Inject, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { SelectProcedureComponent } from './select-procedure/select-procedure.component';
import { PractitionerOrganizationBondDetailsComponent } from './bond-details/organization-bond-details.component';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { Practitionerrole } from 'app/core/interfaces/practitionerrole';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'page-organization-link',
  templateUrl: './organization-link.component.html',
  styleUrls: ['./organization-link.component.scss'],
})
export class PractitionerOrganizationLinkComponent extends BaseComponent implements OnInit {
  public locations: any[] = [];
  public filteredLocations: any[] = [];
  public searchControl = new FormControl('');
  public affiliations: any = [];
  public practitionerLogged: any = {};
  public refreshMainComponent: Boolean = false;
  public showAutocompleteHint: boolean = false;
  public autocompleteSuggestions: string[] = [];
  public showAutocompletePanel: boolean = false;
  public isSelectingSuggestion: boolean = false;
  public practitionerrole !: Practitionerrole;
  public practitioner !: Practitioner
  public dataLoaded: boolean = false


  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private locationService: OrganizationLocationService,
    private practitionerroleService: PractitionerroleService,
    private practitionerService: PractitionerService,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getLocations();

    const currentUser = this.currentUser.user;
    this.practitionerLogged = {
      name: currentUser.name,
      practitioner_id: currentUser.id,
    };

    this.getPractitionerInfo()


    if (this.data.param) {
      this.affiliations = this.data.param.affiliations;
      this.locations = this.data.param.location || [];
      this.filteredLocations = [...this.locations];
    }

    this.setupAutocomplete();
  }

  getPractitionerInfo() {
    const practitioner_id = this.getUserLogged().id;

    forkJoin({
      practitioner: this.practitionerService.showNew(practitioner_id),
      practitionerRole: this.practitionerroleService.findPractitionerByPractitionerroleId(practitioner_id)
    }).subscribe({
      next: ({ practitioner, practitionerRole }) => {
        this.practitioner = practitioner;
        this.practitionerrole = practitionerRole[0];
        this.dataLoaded = true; 
      },
      error: (err) => {
        this.showErrorMessage = true;
         this.dataLoaded = true; 
        console.error(err);
      }
    });
  }


  setupAutocomplete() {
    this.searchControl.valueChanges.pipe(debounceTime(200), distinctUntilChanged()).subscribe((searchTerm: any) => {
      this.updateAutocompleteSuggestions(searchTerm);
      this.filterLocations(searchTerm);
    });
  }

  updateAutocompleteSuggestions(searchTerm: string) {
    if (!searchTerm || searchTerm.length < 3) {
      this.autocompleteSuggestions = [];
      this.showAutocompletePanel = false;
      return;
    }

    const term = searchTerm.toLowerCase();
    const suggestions = new Set<string>();

    this.locations.forEach((location) => {
      const orgName = location.managingOrganization?.name || location.name;
      if (orgName && orgName.toLowerCase().includes(term)) {
        suggestions.add(orgName);
      }
    });

    this.locations.forEach((location) => {
      if (location.address?.[0]?.city && location.address[0].city.toLowerCase().includes(term)) {
        suggestions.add(location.address[0].city);
      }
    });

    this.autocompleteSuggestions = Array.from(suggestions).slice(0, 5);
    this.showAutocompletePanel = this.autocompleteSuggestions.length > 0;
  }

  selectSuggestion(suggestion: string) {
    this.isSelectingSuggestion = true;
    this.searchControl.setValue(suggestion);
    this.showAutocompletePanel = false;
    this.filterLocations(suggestion);

    setTimeout(() => {
      this.isSelectingSuggestion = false;
    }, 200);
  }

  filterLocations(searchTerm: string) {
    if (!searchTerm || searchTerm.length < 3) {
      this.filteredLocations = [...this.locations];
      this.showAutocompleteHint = searchTerm.length > 0 && searchTerm.length < 3;
    } else {
      this.showAutocompleteHint = false;
      const term = searchTerm.toLowerCase();

      this.filteredLocations = this.locations.filter(
        (location) =>
          (location.managingOrganization?.name && location.managingOrganization.name.toLowerCase().includes(term)) ||
          (location.address[0]?.city && location.address[0].city.toLowerCase().includes(term)) ||
          (location.name && location.name.toLowerCase().includes(term))
      );
    }
  }

  onInputFocus() {
    if (this.searchControl.value && this.searchControl.value.length >= 2) {
      this.updateAutocompleteSuggestions(this.searchControl.value);
    }
  }

  onInputBlur() {
    if (!this.isSelectingSuggestion) {
      setTimeout(() => {
        this.showAutocompletePanel = false;
      }, 150);
    }
  }

  getLocations() {

    this.loading = true 
    this.locationService.listLocationForAffiliation().subscribe({
      next: (resLocation: any) => {
        this.locations = resLocation;
        this.filteredLocations = [...resLocation];

         this.loading = false 
      },
      error: (err) => {
        console.log('erro', err);

        this.loading = false 
      },
    });
  }

  getCity(organization_id: string): string | null {
    const location = this.locations.find((loc: any) => loc.organization_id === organization_id);

    if (location && location.address && location.address.length > 0) {
      return location.address[0].city;
    }

    return 'N/A';
  }

  openOrganizationDetailForm(location: any) {
    const data = {
      title: location.managingOrganization?.name,
      param: {
        location: location,
      },
    };

    this.dialog.openMediumComponentDialog(PractitionerOrganizationBondDetailsComponent, data);
  }

  openSelectProcedure(location: any) {
    const data = {
      title: 'Vinculação: ' + location.managingOrganization?.name,
      param: {
        organization: location.managingOrganization,
        location: location,
      },
    };

    this.dialog.openSmallComponentDialog(SelectProcedureComponent, data);
  }



  public isGeoPositionValid(position: any): boolean {
    if (!position) return false;

    const lat = parseFloat(position.latitude);
    const lng = parseFloat(position.longitude);

    const isLatValid = !isNaN(lat) && lat >= -90 && lat <= 90;
    const isLngValid = !isNaN(lng) && lng >= -180 && lng <= 180;

    return isLatValid && isLngValid;
  }

  public hasValidHoursOfOperation(hours: any): boolean {
   
    if (!Array.isArray(hours) || hours.length === 0) {
      return false;
    }

    return hours.every(op =>
      Array.isArray(op.daysOfWeek) && op.daysOfWeek.length > 0 &&
      typeof op.openingTime === 'string' &&
      typeof op.closingTime === 'string'
    );
  }

  public hasLocation(){
    return !this.objectIsEmpty(this.practitioner?.address) 
  }

   public hasSpecialties(){
    return !this.objectIsEmpty(this.practitionerrole) 
  }

  objectIsEmpty(obj?: any): boolean {

    if (obj == null) return true;

    if (Array.isArray(obj)) {
      return obj.length === 0;
    }

    if (typeof obj === 'object') {
      const values = Object.values(obj);
      return values.every(
        v =>
          v === null ||
          v === undefined ||
          (typeof v === 'string' && v.trim() === '')
      );
    }

    return false;
  }

}
